<template>
	<div>
		<!-- event-active  style="display:none" -->
		<div v-if="show" slot="no-body" class="full-page-bg-color">
			<Ev v-for="(vote) in eventVoting" :key='vote.id' :voting='vote' />
		</div>

		<!-- .vote-publish v-if="eventVotingPublish.length > 0" -->
		<div v-if="isVotingPublish" slot="no-body" class="full-page-bg-color">
			<div class="vx-row">
				<table style='border-spacing: 0 2em' class="vx-col lg:w-full">
					<tbody>
						<tr v-for="(vote, index) in eventVotingPublish" :key="index">
							<td
								valign="top"
								class="vx-col w-1/2 md:w-1/2 lg:w-full xl:w-1/2 mb-base"
								style="padding-right: 10px"
							>
								<vx-card>
									<h4>{{ vote.voting_title }}</h4>
									<br />
									<div :id="'vote_' + vote.id">
										<p>
											<strong>{{ $t("VotingTitle") }}: </strong>
											{{ vote.voting_name }}
										</p>
										<p>
											<strong>{{ $t("VotingDescription") }}: </strong>
											<span v-html="vote.voting_description"></span>
										</p>
										<!--p>
											<strong>{{$t('Date')}}: </strong>
											{{vote.voting_end_date }}
										</p-->
										<p>
											<strong>{{ $t("Vote") }}: </strong>
											{{ vote.is_secret == 0 ? $t("NonSecret") : $t("Secret") }}
										</p>
										<!--p>
											<strong>{{ $t('QuorumType') }}: </strong>
											{{ vote.quorum_type_ita }}
										</p-->
										<br />
										<p v-if="vote.type_of_voting === 99">
											<strong>{{ $t("Quorum") }}: </strong>
											<span
												v-if="vote.quorum == true"
												style="border-radius: 50px;background-color: green;padding: 5px 14px;color: #fff;"
												>{{ $t("Passed") }}</span
											>
											<span
												v-else-if="vote.no_votes == vote.yes_votes"
												style="border-radius: 50px;background-color: red;padding: 5px 14px;color: #fff;"
												>{{ $t("Parity") }}</span
											>
											<span
												v-else
												style="border-radius: 50px;background-color: red;padding: 5px 14px;color: #fff;"
												>{{ $t("Failed") }}</span
											>
										</p>
										<br />
										<p>
											<span
												class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-success"
												style="display: inline-block"
											/>
											<span
												>{{ $t("Present") }} :
												{{ vote.present ? vote.present : 0 }}</span
											>
										</p>
										<!--p>
											<span class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-warning" style="display:inline-block"/>
											<span>Delegated  : {{vote.voted }}</span>
										</p>-->
										<p>
											<span
												class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-primary"
												style="display: inline-block"
											/>
											<span>{{ $t("TotalNominal") }} : {{ vote.voted }}</span>
										</p>
										<p v-if="vote.winning_option && vote.type_of_voting != 1">
											<span
												class="ml-1 h-3 w-3 rounded-full mr-4 border-2 border-solid border-primary"
												style="display: inline-block"
											/>
											<span
												>{{ $t("WiningOption") }}:
												{{ $t(vote.winning_option) }}</span
											>
										</p>
										<br />
										<p v-if="vote.is_secret == 0">
											<span
												@click="openDetails(vote.id)"
												style="cursor: pointer"
												>{{ $t("VotingInfo") }}</span
											>
										</p>
										<p v-if="vote.type_of_voting === 99">
											<br />
											<strong>{{ $t("Result") }}: </strong>
											<span
												v-if="vote.quorum == true && vote.winning_option === 'Yes'"
												style="border-radius: 50px;background-color: green;padding: 5px 14px;color: #fff;margin-left: 10px;"
												>{{ $t("Approved") }}</span
											>
											<span
												v-else
												style="border-radius: 50px;background-color: red;padding: 5px 14px;color: #fff;margin-left: 10px;"
											>{{ $t("Rejected") }}</span
											>
										</p>
									</div>
								</vx-card>
							</td>
							<td
								valign="top"
								class="vx-col w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"
								style="padding-left: 10px"
							>
								<vx-card v-if="vote.type_of_voting == 3">
									<h4>{{ $t("Preferences") }}</h4>
									<br />
									<p>
										{{ $t("Yes") }} :
										<span class="float-right">{{ vote.yes_votes }}</span>
										<br />
										<strong
											>{{ parseInt(vote.voted) > 0 ? (Math.round((vote.yes_votes / vote.voted) * 100 * 100	) / 100).toFixed(2)	: "0.00" }}%</strong
										>
										<vs-progress
											class="block mt-1"
											:percent="parseInt(Math.round((vote.yes_votes / vote.voted) * 100 * 100) / 100)"
											color="primary"
										></vs-progress>
									</p>
									<br />
									<p>
										{{ $t("No") }} :
										<span class="float-right">{{ vote.no_votes }}</span>
										<br />
										<strong
											>{{ parseInt(vote.voted) > 0 ? (	Math.round((vote.no_votes / vote.voted) * 100 * 100	) / 100).toFixed(2) : "0.00" }}%</strong
										>
										<vs-progress
											class="block mt-1"
											:percent="parseInt(Math.round((vote.no_votes / vote.voted) * 100 * 100) / 100)"
											color="primary"
										></vs-progress>
									</p>
									<br />
									<p v-if="vote.is_secret == 1">
										{{ $t("Abstained") }} :
										<span class="float-right">{{ vote.abstained }}</span>
										<br />
										<strong
											>{{	parseInt(vote.voted) > 0 ? (Math.round((vote.abstained / vote.voted) * 100 * 100	) / 100).toFixed(2) : "0.00" }}%</strong
										>
										<vs-progress
											class="block mt-1"
											:percent="
												parseInt(
													Math.round(
														(vote.abstained / vote.voted) * 100 * 100
													) / 100
												)
											"
											color="primary"
										></vs-progress>
									</p>
								</vx-card>
								<vx-card v-if="vote.type_of_voting == 1">
									<h4>{{ $t("ElectedCandidates") }}</h4>
									<br />
									<table
										class="candidate-result"
										style="text-align: left !important"
									>
										<tbody>
											<tr
												v-for="(candidate, key) in vote.electedCandidates"
												:key="key"
											>
												<td>
													<span class='text-left'>{{ candidate.candidate_name }}</span>
												</td>
												<td>:</td>
												<td>
													<span class="text-right">{{ candidate.total_votes }}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</vx-card>
								<vx-card v-if="vote.type_of_voting == 2">
									<h4>{{ $t("Preferences") }}</h4>
									<br />
									<div v-for="(option, key) in vote.option_votes" :key="key">
										<p>
											{{ $t(option.options) }} :
											<span class="float-right">{{ option.total_votes }}</span>
											<br />
											<strong
												>{{ parseInt(vote.voted) > 0 ? (Math.round((option.total_votes / vote.voted) * 100 * 100) / 100).toFixed(2)	: "0.00"	}}%</strong
											>
											<vs-progress
												class="block mt-1"
												:percent="parseInt(Math.round((option.total_votes / vote.voted) * 100 * 100) / 100)"
												color="primary"
											></vs-progress>
										</p>
										<br />
									</div>
								</vx-card>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div v-if="isVotingNotStarted">
			<vx-card class="home-card"
				><h4>{{ $t("VotingNotStarted") }}</h4></vx-card
			>
		</div>

		<!-- .no-rights-vote -->
		<div v-if="false && !isRightToVote" slot="no-body" class="full-page-bg-color">
			<vx-card class="home-card">
				<div class="vx-row no-gutter justify-center items-center">
					<div class="vx-col w-full d-theme-dark-bg">
						<div class="p-8 login-tabs-container">
							<div class="vx-col lg:block lg:w-full">
								<img
									v-if="customLogo != ''"
									:src="customLogo"
									alt="login"
									class="mx-auto event-img"
								/>
								<img
									v-else
									src="@/assets/images/pages/maintenance-2.png"
									alt="login"
									class="mx-auto event-img"
								/>
							</div>
							<br />
							<div class="vx-card__title mb-4 justify-center items-center">
								<h4 class="mb-4" style="text-align: center">
									{{ $t("WelcomeEvent") }} {{ event_detail.event_name }}
								</h4>
								<p style="text-align: center; color: orange">
									{{ $t("EventMsg5") }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>

		<vs-popup class="holamundo" :title="$t('UsersVoted')" :active.sync="popupActive2">
			<vs-table :data="userList" pagination :max-items="10" search>
				<template slot="thead">
					<vs-th>{{ $t("FirstName") }}</vs-th>
					<vs-th>{{ $t("LastName") }}</vs-th>
					<vs-th>{{ $t("IdNumber") }}</vs-th>
					<vs-th>{{ $t("Voted") }}</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data">
						<vs-td :data="data[indextr].first_name">{{
							data[indextr].first_name
						}}</vs-td>
						<vs-td :data="data[indextr].last_name">{{
							data[indextr].last_name
						}}</vs-td>
						<vs-td :data="data[indextr].id_number">{{
							data[indextr].id_number
						}}</vs-td>
						<vs-td>
							{{ getVoteString(data[indextr]) }}
						</vs-td>
						<!--            <vs-td :data="data[indextr].value" v-if="currentVotingType == 1 || currentVotingType == 4">-->
						<!--              {{ data[indextr].value.join(', ') }}-->
						<!--            </vs-td>-->
						<!--            <vs-td :data="data[indextr].value" v-if="currentVotingType == 3">-->
						<!--              {{ data[indextr].value == 1 ? $t('Yes') : (data[indextr].value == 0 ? $t('No') : $t('Abstained')) }}-->
						<!--            </vs-td>-->
						<!--            <vs-td :data="data[indextr].value" v-if="currentVotingType == 2">-->
						<!--              {{ $t(data[indextr].value.join(', ')) }}-->
						<!--            </vs-td>-->
					</vs-tr>
				</template>
			</vs-table>
		</vs-popup>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
	name: "EventVoting",
	components: {
		Ev: () => import('./ev')
	},
	data() {
		return {
			show_express: {
				single: [],
				all: []
			},
			express: [],
			checkBox1: [],
			radioBox: [],
			freeTextValues: [],
			freeTextValuesCheckBoxes: [],
			currentExpressVote: null,
			userList: [],
			currentVotingType: null,
			popupActive2: false,
			customLogo: false,
			enterForVote: false,
			astenuto: [],
			enterForVoteArr: [],
			astenutoIds: [],
		};
	},
	computed: {
		...mapGetters([
			"event_listener",
			"event_detail",
			"isSpeaker",
			"isModeratorOrAdmin",
			"isModerator",
			"myself",
			"ipAddress",
		]),
		isAdmin() {
			return this.myself && (this.myself.user_role=='admin' || this.myself.user_role=='admin_observer')
		},
		isRightToVote() {
			return this.$store.state.event.user_right_to_vote != 0 || this.$store.state.event.delegated_for.length > 0;
		},
		confirmation_vote() {
			return this.$store.state.event.confirmation_vote;
		},
		event_vote_start_ids() {
			return this.$store.state.event.event_voting
				.filter((evote) => evote.parent_id != null && evote.status == 1)
				.map((evote) => evote.id);
		},
		event_vote_parent_ids() {
			return this.$store.state.event.event_voting
				.filter(
					(evote) =>
						evote.parent_id != null &&
						(evote.status == 1 || (evote.status != 1 && evote.status != 0))
				)
				.map((evote) => evote.parent_id);
		},
		event_end_vote_id() {
			if (this.event_vote_start_ids.length > 0) return null;
			const a = this.$store.state.event.event_voting.filter(
				(evote) =>
					evote.parent_id != null && evote.status != 1 && evote.status != 0
			);
			return a.length < 1 ? null : a[a.length - 1].id;
		},
		eventVotingPublish() {
			const startedId = this.event_vote_start_ids;
			const parentIds = this.event_vote_parent_ids;
			const endVoteId = this.event_end_vote_id;

			return this.$store.state.event.event_voting
				.filter(
					(evote) =>
						evote.status == 3 &&
						(evote.parent_id == null ||
							(evote.parent_id != null &&
								startedId.length == 0 &&
								endVoteId == evote.id)) &&
						!parentIds.includes(evote.id)
				)
				.map((evote, i) => {
					const vp = evote;
					vp["voting_no"] = i;
					vp.electedCandidates = typeof vp.electedCandidates == "undefined" ? []	: vp.electedCandidates;
					vp.option_votes = typeof vp.option_votes == "undefined" ? [] : vp.option_votes;
					return vp;
				});
		},
		show() {
			const event = this.event_detail;
			return event && (event.status == 1 || event.status == 3);
		},
		isVotingNotStarted() {
			if(this.isVotingPublish)
				return false;
			if(!this.event_detail)
				return false;

			if(this.$store.state.event.event_voting.findIndex(vote => vote.status != 0) > -1)
				return false;
			return true;
			if(this.event && !this.isVotingPublish) {
				if(this.isModeratorOrAdmin || (this.isRightToVote && this.$store.state.event.is_delegated != true))
					return this.$store.state.event.event_voting.findIndex(vote => vote.status != 0) > -1;
			}
			return true;
		},
		isVotingPublish() {
			const event = this.event_detail;
			return (
				event &&
				(event.status == 1 || event.status == 3) &&
				this.eventVotingPublish.length > 0
			);
		},
		eventVoting() {

			/**
			 *
			 evote.type=='agenda' || (eventVotingPublish.some(vp => vp.id == evote.id)===false &&
					((evote.status != 0 && (this.isModeratorOrAdmin || (this.isRightToVote && is_delegated != true && evote.parent_id == null))) ||
					(evote.parent_id != null && (startedId.includes(evote.id) || endVoteId == evote.id))))
			*/
			const startedId = this.$store.getters.event_vote_start_ids;
			const endVoteId = this.$store.getters.event_end_vote_id;
			const is_delegated = this.$store.state.event.is_delegated;
			const eventVotingPublish = this.eventVotingPublish;

			return this.$store.state.event.event_voting
			.filter((evote) => {
				if(evote.type=='agenda')
					return true;
				if(eventVotingPublish.some(vp => vp.id == evote.id)===false) {
					if(evote.status != 0) {
						if(this.isModeratorOrAdmin)
							return true;
						// && is_delegated != true
						if(this.isRightToVote && evote.parent_id == null)
							return true;
					}else if(evote.parent_id != null) {
						if(startedId.includes(evote.id) || endVoteId == evote.id)
							return true;
					}
				}
				return false;
			})
				// .map((evote, i) => {
				//   	evote["voting_no"] = i;
				// 	evote["allVoted"] = null;
				// 	if(evote.type == 'agenda')
				// 		return evote;
				// 	evote.user_votings = typeof evote.user_votings == 'undefined' ? [] : evote.user_votings;
				// 	const user_voting = evote.user_votings.map((voted) =>
				// 		voted.user_id ? voted.user_id : voted.id
				// 	);

				// 	if (singleDelegatesVoteEnabled) {
				// 		evote.allVoted = evote.delegatedForUserIds
				// 		.every((dfui) =>
				// 			user_voting.includes(dfui)
				// 		)
				// 	} else
				// 		evote["allVoted"] = user_voting.includes(this.myself.id) ? 1 : 0;

				// 	const candidates = [[], []]; // [ odd, even ]
				// 	evote.candidates = typeof evote.candidates == "undefined" ? [] : evote.candidates;

				// 	if(isSmallDevice || evote.candidates.length < 40) {
				// 		candidates[0] = [...evote.candidates];
				// 	} else {
				// 		evote.candidates.forEach((candidate, cdx) => {
				// 			candidates[(cdx+1)%2==0?1:0].push(candidate);
				// 		});
				// 	}

				// 	evote.candidates_ = candidates;
				// 	evote.options = typeof evote.options == "undefined" ? [] : evote.options;

				// 	return evote;
				// });
		},
		eventUniqueModifyCode() {
			if(this.event_detail)
				return `${(new Date(this.event_detail.updated_at)).getTime()}-${this.event_detail.id}`;
			return undefined;
		}
	},
	watch: {
		event_listener: function(listen) {
			switch(listen.key) {
				case 'EventVotingTimerUpdate':
          			setTimeout(function () { 
						this.scrollToVote(listen.payload.event_voting_id) 
					}.bind(this), 3000)
					break;
				default: break;
			}
		},
		eventVoting(eventVoting) {
			eventVoting.forEach((vote) => {
				if (typeof this.checkBox1[vote.id] == "undefined")
					this.checkBox1[vote.id] = [];
				if (typeof this.radioBox[vote.id] == "undefined")
					this.radioBox[vote.id] = null;
			});
		},
	},
	created() {
		this.handleAssets();

		const enterForVoteArr = sessionStorage.getItem(`${this.eventUniqueModifyCode}-enter_voting`);
		this.enterForVoteArr = enterForVoteArr ? JSON.parse(enterForVoteArr) : [];

		const show_express = sessionStorage.getItem(`${this.eventUniqueModifyCode}-show_express`, JSON.stringify(this.show_express));
		if(show_express) {
			this.show_express = JSON.parse(show_express);
			this.show_express.all.forEach(vote_id => {
				this.express[vote_id] = `1-${vote_id}`
			});
			this.show_express.single.forEach(vote_id => {
				this.express[vote_id] = `2-${vote_id}`
			});
		}
		
		// this.getEventStatus();
	},
	methods: {
		// simple hack :) :D
		scrollToVote(voteId) {
			this.$nextTick(() => {
				const x = document.getElementById('vote_'+voteId);
				if(x){
					x.scrollIntoView({behavior: "smooth"});
					$('#vote_card_'+voteId).css('box-shadow', '0px 4px 25px 0px rgba(11, 127, 183, 0.9)');
					setTimeout(function () {
						$('#vote_card_'+voteId).css('box-shadow', '0px 4px 25px 0px rgba(0, 0, 0, 0.1)');
					}.bind(this), 3000)
				}
			});
		},

		getVoteString(data) {
			let str = '';
			if (Array.isArray(data.value)) {
				str = data.value.join(', ');
			} else if (data.value === 1) {
				str = 'Yes';
			} else if (data.value === 2) {
				str = 'No';
			} else if (data.isAbsteined) {
				str = 'Abstained';
			} else {
				str = '---';
			}
			return str;
		},
		async handleAssets() {
			this.$vs.loading()
			try{
				const response = await this.$store.dispatch("GetAssets", "event_not_open")
				this.customLogo = response.data.data.path;
			}catch(error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t('FailedToConfigureAssets'),
					text: error,
					color: "danger",
					position: "top-center",
				});
			}
			this.$vs.loading.close();
    	},
		getEventStatus(end_voting_id = null) {
			this.$store.commit('UPDATE_EVENT_LISTENER', {key: 'EventStatus', payload: end_voting_id});
		},

		/**
		 * open popup
		 * @author Madhura Shah
		 */
		openDetails(id) {
			const vote = this.$store.state.event.event_voting.find(
				(ev) => ev.id == id
			);
			this.userList = vote && vote.user_votings ? vote.user_votings : [];
			this.currentVotingType = vote && vote.type_of_voting ? vote.type_of_voting : null;
			this.popupActive2 = true;
		},

	// async addUserVoting(voting_id,request) {
	// 	this.$vs.loading();
	// 	try{
	// 		const response = await this.$store.dispatch("addUserVoting", request);
	// 		this.$vs.notify({
	// 			color: "success",
	// 			text: this.$t("VoteSubmitted"),
	// 			position: "top-center",
	// 		});
	// 		this.getEventStatus(voting_id);
	// 	}catch(err){
	// 	}
	// }

	/**
		 * candidate voting
		 * @author Madhura Shah
		 */
		sumbitAbstained(id, preference_no, userId = this.myself.id) {

		const candIndex = this.astenutoIds.findIndex(function(obj) {
			return obj.vote_id == id;
			});

				this.currentExpressVote = this.express[id];
				this.$vs.loading();
				var data = {
					user_id: userId,
					event_voting_id: id,
					candidates: [this.astenutoIds[candIndex].candidate_id],
					ip_address: this.ipAddress,
					voted_by: this.myself.id,
					is_delegated: userId == this.myself.id ? 0 : 1,
					express: this.express[id],
				};
				this.$store
					.dispatch("addUserVoting", data)
					.then(() => {
						this.checkBox1[id] = [];
						this.getEventStatus(id);
						this.$vs.notify({
							color: "success",
							text: this.$t("VoteSubmitted"),
							position: "top-center",
						});
						this.astenutoIds.splice(candIndex, 1);
						this.$vs.loading.close();
					})
					.catch((error) => {
						this.$log.error(
							"File : Event.vue | Function : sumbitAbstained() | Error :",
							error
						);
						this.$vs.loading.close();
						// Error response
						this.$vs.notify({
							title: this.$t("VoteSubmitError"),
							text: error,
							color: "danger",
							position: "top-center",
						});
						return false;
					});
			}
	},
};
</script>
<style lang="scss" scoped>
.event-img {
	max-width: 600px;
}
.box-shadow{
	box-shadow: 5px 10px red !important;
}
</style>
